export const BecomeProStatuses = {
	NotRequested: 0,
	Requested: 1,
	Approved: 2,
	Rejected: 3,
};
